
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Spinner from "../pages/spinner/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Spinner />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
